(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["braxium-audience-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize=(scope=document)=>scope.querySelectorAll('[data-brx-audience]').forEach(root=>{
  if(root.dataset.initialized)return;
  const track=root.querySelector('.brx-audience__track');
  const slides=[...root.querySelectorAll('.brx-audience__slide')];
  const dots=[...root.querySelectorAll('[data-slide]')];
  const counter=root.querySelector('.brx-audience__count');
  const dialog=root.querySelector('dialog');
  const zoomImage=dialog.querySelector('img');
  let index=0;
  let startX=0;
  let startY=0;
  let suppressUntil=0;
  let pointerActive=false;
  root.dataset.initialized='true';
  const update=()=>{
   const width=track.clientWidth;
   const mobile=root.closest('.brx-premium').clientWidth<=749;
   slides.forEach((slide,i)=>{
    let distance=(i-index+slides.length)%slides.length;
    if(distance>slides.length/2)distance-=slides.length;
    const abs=Math.abs(distance);
    slide.style.setProperty('--card-x',`${distance*width*(mobile?.38:.32)}px`);
    slide.style.setProperty('--card-z',`${-abs*(mobile?95:150)}px`);
    slide.style.setProperty('--card-angle',`${distance*-20}deg`);
    slide.style.setProperty('--card-scale',String(abs===0?1:abs===1?.88:.72));
    slide.style.setProperty('--card-brightness',String(abs===0?1:.66));
    slide.style.setProperty('--card-opacity',String(abs>1?0:1));
    slide.style.setProperty('--card-order',String(5-abs));
    slide.style.pointerEvents=abs>1?'none':'auto';
    slide.classList.toggle('is-active',i===index);
    slide.setAttribute('aria-hidden',String(i!==index));
    slide.querySelector('a').tabIndex=i===index?0:-1;
   });
   track.style.height=`${Math.ceil(slides[index].offsetHeight+56)}px`;
   counter.textContent=`${index+1} / ${slides.length}`;
   dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
  };
  const go=target=>{index=(target+slides.length)%slides.length;update();};
  root.querySelector('[data-prev]').addEventListener('click',()=>go(index-1));
  root.querySelector('[data-next]').addEventListener('click',()=>go(index+1));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
  track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(index+(event.key==='ArrowRight'?1:-1));}});
  track.addEventListener('pointerdown',event=>{if(event.button!==0)return;startX=event.clientX;startY=event.clientY;pointerActive=true;});
  track.addEventListener('pointercancel',()=>{pointerActive=false;});
  track.addEventListener('pointerleave',()=>{pointerActive=false;});
  track.addEventListener('pointerup',event=>{if(!pointerActive)return;pointerActive=false;const dx=event.clientX-startX;const dy=event.clientY-startY;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)){suppressUntil=Date.now()+400;go(index+(dx<0?1:-1));}});
  track.addEventListener('dragstart',event=>event.preventDefault());
  root.querySelectorAll('[data-enlarge]').forEach((link,i)=>link.addEventListener('click',event=>{
   if(Date.now()<suppressUntil){event.preventDefault();return;}
   if(i!==index){event.preventDefault();go(i);return;}
   if(typeof dialog.showModal!=='function')return;
   event.preventDefault();zoomImage.src=link.href;zoomImage.alt=link.querySelector('img').alt;dialog.showModal();dialog.querySelector('.brx-audience__zoom').scrollTo(0,0);
  }));
  root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
  slides.forEach(slide=>slide.querySelector('img').addEventListener('load',update));
  new ResizeObserver(update).observe(track);
  root.querySelector('.brx-audience__controls').hidden=false;
  update();
 });
 initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["braxium-brain-facts"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeFacts() {
    document.querySelectorAll('[data-bxb-facts]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('[data-bxb-track]');
      const fill = root.querySelector('[data-bxb-fill]');
      const cards = Array.from(track.querySelectorAll('.bxb-facts__card'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let paused = false;
      let pausedUntil = 0;
      function progress() {
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const visibleFraction = Math.min(1, track.clientWidth / track.scrollWidth);
        const fraction = Math.max(0, Math.min(1, track.scrollLeft / max));
        fill.style.width = ((visibleFraction + (1 - visibleFraction) * fraction) * 100) + '%';
      }
      function step() {
        if (!visible || paused || reduceMotion.matches || Date.now() < pausedUntil) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (max <= 2) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const one = cards[0].getBoundingClientRect().width + gap;
        const next = track.scrollLeft + one;
        track.scrollTo({left: next >= max - 2 ? 0 : next, behavior: 'smooth'});
      }
      track.addEventListener('scroll', progress, {passive: true});
      track.addEventListener('touchstart', () => {pausedUntil = Date.now() + 12000;}, {passive:true});
      track.addEventListener('pointerdown', () => {pausedUntil = Date.now() + 12000;});
      track.addEventListener('mouseenter', () => {paused = true;});
      track.addEventListener('mouseleave', () => {paused = false;});
      root.addEventListener('focusin', () => {paused = true;});
      root.addEventListener('focusout', () => {paused = false;});
      if ('IntersectionObserver' in window) {
        const watcher = new IntersectionObserver((entries) => {visible = entries[0].isIntersecting;}, {threshold: 0.18});
        watcher.observe(root);
      } else {visible = true;}
      window.addEventListener('resize', progress, {passive:true});
      progress();
      const interval = window.setInterval(() => {
        if (!root.isConnected) {window.clearInterval(interval);return;}
        step();
      }, 5900);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFacts, {once:true});
  else initializeFacts();
  document.addEventListener('shopify:section:load', initializeFacts);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["braxium-formula-video"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize = (scope = document) => scope.querySelectorAll('.brx-formula-video video').forEach(video => {
  if (video.dataset.autoReady) return;
  video.dataset.autoReady = 'true';
  video.muted = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  const update = () => {
   if (reduced.matches || !visible || document.hidden) video.pause();
   else video.play().catch(() => {});
  };
  new IntersectionObserver(entries => {visible = entries[0].isIntersecting;update();},{threshold:.1}).observe(video);
  reduced.addEventListener('change',update);
  document.addEventListener('visibilitychange',update);
  update();
 });
 initialize();
 document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
